import { Address } from '@occc/graphql';

export const formatFullAddress = (address?: Partial<Address> | null) => {
  if (!address) return '';

  const parts = [address.street1, address.street2, address.city];
  const stateZip = [address.state, address.zipCode];

  parts.push(stateZip.filter(Boolean).join(' '));
  return parts.filter(Boolean).join(', ');
};
